export default class TaxCalculator {

    constructor(){
        this.TPS = 0.05;
        this.TVQ = 0.09975;
        this.CombinedTaxes = 1 + this.TPS + this.TVQ;
    }
    
    calculateTPS(price)
    {
        return ((price / this.CombinedTaxes) * this.TPS).toFixed(2)
    }

    calculateTVQ(price)
    {
        return ((price / this.CombinedTaxes) * this.TVQ).toFixed(2)
    }
}


// WEBPACK FOOTER //
// ./src/components/TaxCalculator.js